export {CookieBannerComponent} from './CookieBannerComponent';
export type {CookieBannerComponentDefinition} from './CookieBannerComponent';
export {ComponentDefinition} from './CookieBannerDefinition';
export type {SchemaType} from './CookieBannerDefinition';
export {CookieBannerPreviewComponent} from './CookieBannerPreviewComponent';

import {Registry} from '@backstage-components/base';
import {CookieBannerModule} from './CookieBannerModule';
import {ComponentDefinition} from './CookieBannerDefinition';
Registry.register(ComponentDefinition, CookieBannerModule);
